export const contentsWithLinks = {
  images: [
    {
      filename: 'Icon-40.png',
      idiom: 'iphone',
      scale: '2x',
      size: '20x20',
    },
    {
      filename: 'Icon-60.png',
      idiom: 'iphone',
      scale: '3x',
      size: '20x20',
    },
    {
      filename: 'Icon-58.png',
      idiom: 'iphone',
      scale: '2x',
      size: '29x29',
    },
    {
      filename: 'Icon-87.png',
      idiom: 'iphone',
      scale: '3x',
      size: '29x29',
    },
    {
      filename: 'Icon-80.png',
      idiom: 'iphone',
      scale: '2x',
      size: '40x40',
    },
    {
      filename: 'Icon-120.png',
      idiom: 'iphone',
      scale: '3x',
      size: '40x40',
    },
    {
      filename: 'Icon-120.png',
      idiom: 'iphone',
      scale: '2x',
      size: '60x60',
    },
    {
      filename: 'Icon-180.png',
      idiom: 'iphone',
      scale: '3x',
      size: '60x60',
    },
    {
      filename: 'Icon-1024.png',
      idiom: 'ios-marketing',
      scale: '1x',
      size: '1024x1024',
    },
  ],
  info: {
    author: 'xcode',
    version: 1,
  },
}
